import * as React from "react";
interface props {
  className?: string;
}

const NeighbourhoodSvg = ({ className }: props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    // width="70"
    // height="70"
    className={className}
    fill="none"
    viewBox="0 0 70 70"
  >
    <path
      fill="#FF752C"
      d="M32.234 1.8c-.077-.927.613-1.746 1.543-1.779A35 35 0 1 1 14.755 6.45c.76-.538 1.804-.306 2.306.479.5.784.268 1.822-.488 2.365a31.63 31.63 0 1 0 17.484-5.909c-.93.028-1.745-.656-1.823-1.584"
    ></path>
    <path
      fill="#A1A0A0"
      d="M34.625 41.408a.75.75 0 0 0 .744 0c.23-.133 5.625-3.282 5.625-8.902A6 6 0 0 0 29 32.501c0 5.626 5.398 8.77 5.625 8.907M35 30.25a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5m10.5 12c0 2.924-5.41 4.5-10.5 4.5s-10.5-1.576-10.5-4.5c0-1.367 1.24-2.579 3.49-3.41a.75.75 0 0 1 .52 1.407c-1.548.573-2.51 1.34-2.51 2.004 0 1.252 3.424 3 9 3s9-1.748 9-3c0-.664-.962-1.431-2.51-2.003a.75.75 0 0 1 .52-1.406c2.25.83 3.49 2.04 3.49 3.408"
    ></path>
  </svg>
);

export default NeighbourhoodSvg;
